import { render, staticRenderFns } from "./Signinpop.vue?vue&type=template&id=2bc665b5&scoped=true"
import script from "./Signinpop.vue?vue&type=script&lang=js"
export * from "./Signinpop.vue?vue&type=script&lang=js"
import style0 from "./Signinpop.vue?vue&type=style&index=0&id=2bc665b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc665b5",
  null
  
)

export default component.exports